<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Lista banner</h2>
        <v-btn color="primary" size="small" @click="$router.push('/banners/new')">Nuovo</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.title" label="Nome" clearable></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="banners" view-sub-path="" :viewable="false" :editable="true" deletable :query="query" @error="onListError">

          <template v-slot:item.src="{ item }">
            <v-img :src="item.src" :aspect-ratio="320/50" class="flex-shrink-0 cursor-pointer" min-width="200" @click="$router.push(`/banners/${item._id}`)"></v-img>
          </template>

          <template v-slot:item.exp="{ item }">
            {{formatDate(item.exp)}}
          </template>
          
          
          <template v-slot:item.title="{ item }">
            <a @click="$router.push(`/banners/${item._id}`)" ><strong>{{ item.title }}</strong></a>
          </template>

          <template v-slot:item.pub="{ item }">
            <strong class="text-success" v-if="item.pub">Sì</strong>
            <span class="text-error" v-else>No</span>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";


export default defineComponent({
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()
    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})


    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      /*
      await Promise.all([
        globals.refresh('categories'),
        globals.refresh('difficulties'),
      ])*/
      query.value = utils.getSessionQuery("banners")
      wh = watch(query.value, ()=>{
        utils.setSessionQuery("banners", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      dataTable,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title : 'Immagine', sortable: false, align: 'left', value : 'src', width: 250 },
        { title : 'Nome', sortable: true, align: 'left', value : 'title' },
        { title : 'Scadenza', sortable: true, align: 'left', value : 'exp' },
        { title : 'Priorità', sortable: true, align: 'left', value : 'priority' },
        { title : 'Pubblicato', sortable: true, align: 'left', value : 'pub' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      formatDate : utils.formatDate,
    }
  }
})
</script>
